// extracted by mini-css-extract-plugin
export default {"ChevronIcon":"UpAndDownIcon_ChevronIcon__8zS47"};